<template lang="html">
    <div class="preview-wxpay">
        <iframe class="frame-style" src="https://test-pipay.pingan.com/epcis_nps/su/79b50krR78aa79"></iframe>
    </div>
</template>

<script>

    export default {
        components: {

        },
        data() {
            return {

            }
        },
        methods: {

        },
        mounted() {

        }
    }
</script>

<style lang="less" scoped>
   .preview-wxpay{
       width: 100%;
       height: 100%;
   }
    .frame-style {
        width: 100%;
        height: 100%;
        border: 0;
    }
</style>
